"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Base_1 = require("../modals/Base");
const icons_1 = require("../../atoms/icons");
const faTimes_1 = require("@fortawesome/pro-light-svg-icons/faTimes");
const useProgressiveImg_1 = require("../../shared/hooks/useProgressiveImg");
const Spinner_1 = require("../../molecules/loading/Spinner");
const hooks_1 = require("../../shared/hooks");
const typography_1 = require("../../shared/typography");
const BaseMobile_1 = require("../modals/BaseMobile");
const AttachmentModal = ({ onClose, attachment, label }) => {
    const photoContainerRef = (0, react_1.createRef)();
    const { isMobile } = (0, hooks_1.useRWD)();
    const [src, { isBlur }] = (0, useProgressiveImg_1.useProgressiveImg)(attachment.sizes.thumbnail.url, attachment.sizes.large.url);
    const [state, setState] = (0, react_1.useState)({
        shouldStretchVertically: false,
        shouldStretchHorizontally: false,
        done: false,
        imgHeight: 0,
        imgWidth: 0
    });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!isMobile &&
            attachment.sizes.large.size.height <
                (((_a = photoContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0)) {
            setState({
                ...state,
                done: true,
                shouldStretchVertically: false,
                imgHeight: attachment.sizes.large.size.height
            });
        }
        else if (isMobile &&
            attachment.sizes.large.size.width <
                (((_b = photoContainerRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0)) {
            setState({
                ...state,
                done: true,
                shouldStretchHorizontally: false,
                imgWidth: attachment.sizes.large.size.width
            });
        }
        else {
            setState({
                ...state,
                done: true,
                shouldStretchVertically: true,
                shouldStretchHorizontally: true
            });
        }
    }, []);
    const onClick = (e) => {
        e.stopPropagation();
    };
    if (isMobile) {
        return ((0, jsx_runtime_1.jsx)(BaseMobile, { content: (0, jsx_runtime_1.jsxs)(Content, { isBlur: isBlur, shouldStretchVertically: state.shouldStretchVertically, shouldStretchHorizontally: state.shouldStretchHorizontally, imgHeight: state.imgHeight, imgWidth: state.imgWidth, onClick: onClick, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: label }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faTimes_1.faTimes, size: "lg", onClick: onClose }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { ref: photoContainerRef, className: "photo", children: [state.done && (0, jsx_runtime_1.jsx)("img", { src: src }, void 0), isBlur && (0, jsx_runtime_1.jsx)(Spinner, {}, void 0)] }, void 0)] }, void 0) }, void 0));
    }
    return ((0, jsx_runtime_1.jsx)(ModalBase, { onCloseModal: onClose, children: (0, jsx_runtime_1.jsxs)(Content, { isBlur: isBlur, shouldStretchVertically: state.shouldStretchVertically, shouldStretchHorizontally: state.shouldStretchHorizontally, imgHeight: state.imgHeight, imgWidth: state.imgWidth, onClick: onClick, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: label }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faTimes_1.faTimes, size: "lg", onClick: onClose }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { ref: photoContainerRef, className: "photo", children: [state.done && (0, jsx_runtime_1.jsx)("img", { src: src }, void 0), isBlur && (0, jsx_runtime_1.jsx)(Spinner, {}, void 0)] }, void 0)] }, void 0) }, void 0));
};
exports.AttachmentModal = AttachmentModal;
const ModalBase = (0, styled_components_1.default)(Base_1.ModalBase) `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const BaseMobile = (0, styled_components_1.default)(BaseMobile_1.BaseMobile) `
  & > div {
    padding: ${({ theme }) => `${theme.spacings.xl} 0 0`};
  }
`;
const Content = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  height: 75%;
  width: 75%;

  & > div:first-of-type {
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    display: flex;
    height: 2rem;
    justify-items: flex-end;
    padding: ${({ theme }) => `0 ${theme.spacings.m}`};
    width: 100%;

    & > p {
      flex: 1;
      font-size: 0.75rem;
      margin-bottom: 0;
      text-align: center;
    }

    & > div {
      cursor: pointer;
      flex: 0;
    }
  }

  .photo {
    align-items: center;
    display: flex;
    height: calc(100% - 2rem);
    justify-items: center;
    position: relative;
    width: 100%;

    img {
      filter: blur(${({ isBlur }) => (isBlur ? 4 : 0)}px);
      display: block;
      height: ${({ shouldStretchVertically, imgHeight }) => shouldStretchVertically ? `100%` : `${imgHeight}px`};
      margin: 0 auto;
      object-fit: contain;
      width: auto;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    border: none;
    height: 100%;
    width: 100%;

    .photo {
      img {
        width: ${({ shouldStretchHorizontally, imgWidth }) => shouldStretchHorizontally ? `100%` : `${imgWidth}px`};
        height: 100%;
      }
    }
  }
`;
const Spinner = (0, styled_components_1.default)(Spinner_1.Spinner) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
//# sourceMappingURL=AttachmentModal.js.map